import styled from "styled-components";

const ModalHelpText = styled.p`
	font-weight: 500;
	margin-bottom: 1em;
`;

export default ModalHelpText;
